<template>
  <div class="pi-product-ingredient wrapper">
    <!-- 搜索筛选区 -->
    <section class="pi-search-card">
      <div class="pi-search-bar">
        <el-radio-group v-model='search.state' class="pi-state-seg" @change="handleSearch">
          <el-radio-button label=''>全部</el-radio-button>
          <el-radio-button v-for="item in StateMap" :label='item.value' :key="item.value">
            {{ item.label }}
          </el-radio-button>
        </el-radio-group>
        <el-input v-model='search.title' placeholder='模糊搜索产品名称' clearable class="pi-search-input" @change="handleSearch">
          <i slot="prefix" class="el-icon-search"></i>
        </el-input>
        <el-input v-model='search.id' placeholder='模糊搜索产品ID' clearable class="pi-search-input" @change="handleSearch">
          <i slot="prefix" class="el-icon-search"></i>
        </el-input>
        <el-button type="primary" icon="el-icon-search" size="mini" class="pi-btn-primary" @click="handleSearch">查询</el-button>
        <el-button icon="el-icon-refresh-left" size="mini" class="pi-btn-ghost" @click="handleResetSearch">重置</el-button>
        <el-button v-if="userPermissions.indexOf('ai_tools__product_ingredients_list') !== -1"
                   class="pi-btn-ingredient" size="mini" @click="handleShowIngredient">
          <i class="el-icon-s-data"></i> 成份表
        </el-button>
        <div class="pi-search-actions">
          <product-ingredient-save ref="save" @success="handleSearch" />
          <product-ingredient-see ref="see" @success="handleSearch" />
          <product-ingredient-see-ocr ref="ProductIngredientSeeOcr" />
        </div>
      </div>
    </section>

    <!-- 列表区 -->
    <section class="pi-table-card">
      <ml-table ref="TABLE" :api="apiList" :search="search" :default-page-size="15" class="pi-main-table">
        <template slot="columns">
          <el-table-column type="selection" width="55" />
          <el-table-column label="ID" prop="id" width="70" show-overflow-tooltip />
          <el-table-column label="产品名称" prop="title" min-width="180" show-overflow-tooltip />
          <el-table-column label="状态" width="110">
            <template v-slot="{row:{state}}">
              <span class="pi-status-badge" :class="stateCls(state)">
                <i class="pi-status-dot"></i>
                <span v-if="StateMap[state]">{{ StateMap[state].label }}</span>
                <span v-else>{{ state }}</span>
              </span>
            </template>
          </el-table-column>
          <el-table-column label="成分图" align="left" min-width="150">
            <template v-slot="{row:{ingredient_url}}">
              <span v-if="!Array.isArray(ingredient_url) || !ingredient_url.length" class="pi-empty-text">无</span>
              <div v-else class="pi-thumb-list">
                <el-image
                  v-for="(item,i) in ingredient_url" :key="i"
                  class="pi-thumb"
                  :src="item.url"
                  :preview-src-list="ingredient_url.map(u => u.url)"
                  fit="cover">
                  <div slot="error" class="pi-thumb__error"><i class="el-icon-picture-outline"></i></div>
                </el-image>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="文本识别" prop="ocr" align="center" min-width="100">
            <template v-slot='{row}'>
              <el-button v-if="row.state === 'O' || row.state === 'D'" plain round size='mini' class="pi-link-btn" @click="handleSeeOcr(row)">
                查看
              </el-button>
              <span v-else class="pi-empty-text">-</span>
            </template>
          </el-table-column>
          <el-table-column label="成分分析" prop="propose_ai" align="center" min-width="100">
            <template v-slot='{row}'>
              <el-button v-if="row.state === 'D'" plain round size='mini' class="pi-link-btn" @click="handleSeeAi(row)">
                查看
              </el-button>
              <span v-else class="pi-empty-text">-</span>
            </template>
          </el-table-column>
          <el-table-column prop="model_nm" label="解析模型" align="center" min-width="110" show-overflow-tooltip />
          <el-table-column prop="ocr_at" label="识别时间" align="center" min-width="130" show-overflow-tooltip />
          <el-table-column prop="ai_at" label="分析时间" align="center" min-width="130" show-overflow-tooltip />
          <el-table-column prop="created_at" label="创建时间" align="center" min-width="130" show-overflow-tooltip />
          <el-table-column prop="updated_at" label="修改时间" align="center" min-width="130" show-overflow-tooltip />
          <el-table-column label="操作" width="150" fixed="right" align="center">
            <template v-slot='{row}'>
              <el-button plain round size='mini' class="pi-op-btn pi-op-btn--primary" @click="handleEdit(row)">修改</el-button>
              <el-button plain round size='mini' class="pi-op-btn pi-op-btn--danger" @click='handleDelete(row.id)'>删除</el-button>
            </template>
          </el-table-column>
        </template>
        <template slot="footer">
          <el-button size="mini" class="pi-reset-btn" @click="handleReset">批量重置解析</el-button>
        </template>
      </ml-table>
    </section>

    <!--  成分表弹窗  -->
    <el-dialog custom-class="pi-ingredient-dialog" title='成份表' :visible.sync='ingredientDialog.show'
               width='75%' append-to-body :close-on-click-modal='false'>
      <div class="pi-dialog-bar">
        <div>
          <el-button type="primary" icon="el-icon-search" size="mini" class="pi-btn-primary" @click="handleAiParseIngredientSearchList">
            查询
          </el-button>
        </div>
        <div>
          <el-button v-if="userPermissions.indexOf('ai_tools__product_ingredients_save') !== -1" type="warning"
                     icon="el-icon-refresh" size="mini" class="pi-btn-sync" @click="handleAiParseIngredientRunSyncScript">
            同步AI解析成分
          </el-button>
        </div>
      </div>
      <div class="pi-dialog-table">
        <el-table ref="ingredientTable" v-loading="ingredientDialog.load" :data="ingredientDialog.list"
                  highlight-current-row border style="width: 100%">
          <el-table-column type="index" label="序号" width="70" align="center" />
          <el-table-column property="nm" label="成分" width="200" align="center" />
          <el-table-column property="model_nm" label="模型" min-width="200" align="center" />
          <el-table-column property="effect" label="作用" width="200" align="center" />
          <el-table-column property="allergy" label="刺激性/致敏性" width="200" align="center" />
          <el-table-column property="score" label="安全分" width="70" align="right" header-align="center" />
          <el-table-column property="remark" label="备注" width="300" align="center" />
        </el-table>
        <el-pagination class="pi-dialog-pager"
                       @size-change="handleAiParseIngredientPrivacySizeChange"
                       @current-change="handleAiParseIngredientPrivacyPageChange"
                       :current-page="ingredientDialog.pages.current_page"
                       :page-sizes="[5, 10, 20, 50, 100]"
                       :page-size="ingredientDialog.pages.page_size"
                       layout="total, sizes, prev, pager, next"
                       :total="ingredientDialog.pages.total">
        </el-pagination>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import MlTable from '@/components/MlTable/index.vue'
import { productIngredientDelete, productIngredientList, productIngredientReset } from '@/api/product-ingredients'
import { aiParseIngredientSearchList, aiParseIngredientRunSyncScript } from '@/api/ai_parse_ingredient'
import ProductIngredientSave from '@/pages/product/ingredients/save.vue'
import ProductIngredientSee from '@/pages/product/ingredients/see-ingredient.vue'
import ProductIngredientSeeOcr from '@/pages/product/ingredients/see-ocr.vue'
import { mapGetters } from 'vuex'

/********* 状态 *********/
const StateMap = {
  N: { label: '未解析', color: '#909399', value: 'N' },
  H: { label: '需人工处理', color: '#fe5a1e', value: 'H' },
  O: { label: '文本已识别', color: '#5E7CE0', value: 'O' },
  F: { label: '解析失败', color: '#FE1E1E', value: 'F' },
  D: { label: '解析完成', color: '#24BA0C', value: 'D' },
  U: { label: '未配置', color: '#303133', value: 'U' },
}
export default {
  name: 'ProductIngredientsList',
  components: { ProductIngredientSee, ProductIngredientSeeOcr, ProductIngredientSave, MlTable },
  computed: {
    ...mapGetters(['userPermissions'])
  },
  data() {
    return {
      StateMap,
      search: {
        state: '',
        title: '',
      },
      ingredientDialog: {
        show: false,
        load: true,
        query: {},
        list: [],
        pages: { current_page: 1, page_size: 10, total: 0 },
      },
    }
  },
  methods: {
    apiList: productIngredientList,
    /**
     * 状态徽标样式类
     * @param state
     * @returns {string}
     */
    stateCls: function(state) {
      return 'pi-status--' + String(state || '').toLowerCase()
    },
    /**
     * 查看
     * @param row
     */
    handleSeeAi: function(row) {
      this.$refs.see.interfaceSee(row)
    },
    handleSeeOcr: function(row) {
      this.$refs.ProductIngredientSeeOcr.interfaceSee(row)
    },
    handleReset: function() {
      const selection = this.$refs.TABLE.getSelection()
      const ids = selection.map(_ => {
        return _.id
      })
      const length = ids.length
      if (length <= 0) {
        this.$message.warning('请选择数据')
        return false
      }
      this.$confirm(
        `已选中${length}条数据确认重置吗？`,
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
        await productIngredientReset({ ids })
        this.$message({
          type: 'success',
          message: '操作成功!'
        })
        this.handleSearch()
      })
    },
    /**
     * 编辑按钮
     * @param row
     * @return {Promise<void>}
     */
    async handleEdit(row) {
      this.$refs.save.interfaceEdit(row)
    },
    /** 删除按钮 */
    handleDelete(id) {
      this.$confirm('此操作将删除数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await productIngredientDelete({ id })
        this.$message({
          type: 'success',
          message: '删除成功!'
        })
        this.handleSearch()
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    handleSearch: function() {
      this.$refs[`TABLE`].handleSearch && this.$refs[`TABLE`].handleSearch()
    },
    handleResetSearch: function() {
      this.search = {
        state: '',
        title: ''
      }
      this.$nextTick(() => {
        this.handleSearch()
      })
    },
    handleShowIngredient: function() {
      this.ingredientDialog.show = true
      this.ingredientDialog.list = []
      this.ingredientDialog.pages = { current_page: 1, page_size: 10, total: 0 }
      this.handleAiParseIngredientSearchList()
    },
    handleAiParseIngredientSearchList: async function() {
      this.ingredientDialog.load = true
      this.handleAiParseIngredientQueryWhere()
      const { list, pages } = await aiParseIngredientSearchList(this.ingredientDialog.query)
      this.ingredientDialog.list = list || []
      this.ingredientDialog.pages = pages || { current_page: 1, page_size: 10, total: 0 }
      this.ingredientDialog.load = false
    },
    handleAiParseIngredientQueryWhere: function() {
      this.ingredientDialog.query = {
        current_page: this.ingredientDialog.pages.current_page,
        page_size: this.ingredientDialog.pages.page_size,
      }
    },
    handleAiParseIngredientPrivacyPageChange(page) {
      this.ingredientDialog.pages.current_page = page
      this.handleAiParseIngredientSearchList()
    },
    handleAiParseIngredientPrivacySizeChange(size) {
      this.ingredientDialog.pages.page_size = size
      this.ingredientDialog.pages.current_page = 1
      this.handleAiParseIngredientSearchList()
    },
    handleAiParseIngredientRunSyncScript: async function() {
      await aiParseIngredientRunSyncScript()
    }
  }
}
</script>
<style lang="scss" scoped>
// ===== AI参谋 · 产品成分 —— 页面样式（仅作用于本页面） =====
// 品牌主色
$pi-primary: #ff3176;
$pi-primary-light: #fff0f5;
$pi-primary-hover: #ff6b9a;
$pi-text-main: #303133;
$pi-text-sub: #606266;
$pi-text-muted: #909399;
$pi-bg: #f5f6fa;
$pi-card-bg: #ffffff;
$pi-border: #f0f1f5;
$pi-shadow: 0 6px 24px rgba(31, 35, 66, 0.06);

.pi-product-ingredient {
  background: $pi-bg;
  height: 100%;
  min-height: 100%;
  padding: 20px 24px 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  box-sizing: border-box;
  overflow: hidden;

  ::v-deep .el-message {
    z-index: 3000;
  }

  // ===== 搜索卡片 =====
  .pi-search-card {
    background: $pi-card-bg;
    border-radius: 14px;
    box-shadow: $pi-shadow;
    padding: 16px 20px 18px;
    flex: none;
  }

  .pi-search-bar {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;

    ::v-deep .el-button {
      border-radius: 8px;
      height: 32px;
      line-height: 30px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
    }
  }

  .pi-search-actions {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-left: auto;
  }

  .pi-btn-primary {
    background: $pi-primary;
    border-color: $pi-primary;
    color: #fff;

    &:hover {
      background: $pi-primary-hover;
      border-color: $pi-primary-hover;
    }
  }

  .pi-btn-ghost {
    color: $pi-text-sub;
    border-color: #e3e5ec;
    background: #fff;

    &:hover {
      color: $pi-primary;
      border-color: $pi-primary;
      background: $pi-primary-light;
    }
  }

  .pi-btn-ingredient {
    color: $pi-primary;
    border-color: $pi-primary;
    background: $pi-primary-light;

    &:hover {
      background: $pi-primary;
      border-color: $pi-primary;
      color: #fff;
    }
  }

  // 状态分段控件
  .pi-state-seg {
    display: inline-flex;

    ::v-deep .el-radio-button__inner {
      padding: 0 16px;
      height: 32px;
      line-height: 30px;
      border-color: #eef0f4;
      background: #fafbfd;
      color: $pi-text-sub;
      font-size: 12px;
      transition: all .2s ease;
    }

    ::v-deep .el-radio-button:first-child .el-radio-button__inner {
      border-radius: 8px 0 0 8px;
    }

    ::v-deep .el-radio-button:last-child .el-radio-button__inner {
      border-radius: 0 8px 8px 0;
    }

    ::v-deep .el-radio-button__inner:hover {
      color: $pi-primary;
    }

    ::v-deep .el-radio-button__orig-radio:checked + .el-radio-button__inner {
      background: $pi-primary;
      border-color: $pi-primary;
      box-shadow: -1px 0 0 0 $pi-primary;
      color: #fff;
      font-weight: 600;
    }
  }

  // 搜索输入框
  .pi-search-input {
    width: 240px;

    ::v-deep .el-input__inner {
      border-radius: 8px;
      border-color: #e3e5ec;
      height: 32px;
      line-height: 32px;

      &:focus {
        border-color: $pi-primary;
      }
    }

    ::v-deep .el-input__prefix {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
    }

    ::v-deep .el-input__prefix .el-icon-search {
      color: #c0c4cc;
      font-size: 14px;
      line-height: 1;
    }
  }

  // ===== 表格卡片 =====
  .pi-table-card {
    flex: 1;
    background: $pi-card-bg;
    border-radius: 14px;
    box-shadow: $pi-shadow;
    padding: 8px 12px 14px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }

  .pi-main-table {
    height: 100%;

    ::v-deep .ml-table-container {
      height: 100%;
      display: flex;
      flex-direction: column;
    }

    // 表头
    ::v-deep .el-table th.el-table__cell {
      background: linear-gradient(180deg, #fafbff, #f4f5fb);
      color: #4a4e63;
      font-weight: 600;
      font-size: 12.5px;
      border-bottom: 1px solid #eef0f5;
    }

    // 去掉生硬外边框，只保留分隔线
    ::v-deep .el-table--border,
    ::v-deep .el-table--group,
    ::v-deep .el-table--border::after,
    ::v-deep .el-table__fixed-right::before {
      border: none;
    }

    ::v-deep .el-table td.el-table__cell,
    ::v-deep .el-table th.el-table__cell {
      border-bottom: 1px solid #f3f4f8;
    }

    ::v-deep .el-table--border .el-table__cell,
    ::v-deep .el-table__body-wrapper .el-table__cell {
      border-right: none;
    }

    // 行高与悬浮
    ::v-deep .el-table .el-table__row td.el-table__cell {
      padding: 5px 0;
    }

    ::v-deep .el-table .el-table__row:hover > td.el-table__cell {
      background: $pi-primary-light !important;
    }

    ::v-deep .el-table__body tr.current-row > td.el-table__cell {
      background: $pi-primary-light !important;
    }

    // 滚动条
    ::v-deep .el-table__body-wrapper::-webkit-scrollbar {
      width: 8px;
      height: 8px;
    }

    ::v-deep .el-table__body-wrapper::-webkit-scrollbar-thumb {
      background: #e0e2ea;
      border-radius: 4px;
    }

    // 底部（重置 + 分页）
    ::v-deep .ml-table-container__footer {
      margin-top: 4px;
      padding-top: 14px;
      border-top: 1px solid #f3f4f8;

      .el-pagination {
        font-weight: 400;
      }

      .el-pager li {
        border-radius: 6px;
        margin: 0 2px;

        &:hover {
          color: $pi-primary;
        }

        &.active {
          background: $pi-primary;
          color: #fff;
        }
      }
    }
  }

  .pi-reset-btn {
    font-size: 13px;
    background: $pi-primary;
    border-color: $pi-primary;
    color: #fff;
    border-radius: 8px;

    &:hover {
      background: $pi-primary-hover;
      border-color: $pi-primary-hover;
      color: #fff;
    }
  }

  // ===== 状态徽标 =====
  .pi-status-badge {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 3px 10px;
    border-radius: 20px;
    font-size: 12px;
    line-height: 18px;
    white-space: nowrap;

    .pi-status-dot {
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background: currentColor;
      flex: none;
    }

    &.pi-status--n { color: #909399; background: #f2f3f5; }
    &.pi-status--h { color: #e8590c; background: #fff1e8; }
    &.pi-status--o { color: #3b67d8; background: #eef2ff; }
    &.pi-status--f { color: #f5483b; background: #ffefee; }
    &.pi-status--d { color: #12a150; background: #e9f9ef; }
    &.pi-status--u { color: #4e5362; background: #eff0f4; }
  }

  // ===== 成分图缩略图 =====
  .pi-thumb-list {
    display: flex;
    gap: 8px;
  }

  .pi-thumb {
    width: 44px;
    height: 44px;
    border-radius: 10px;
    overflow: hidden;
    border: 1px solid #f0f1f5;
    box-shadow: 0 2px 6px rgba(31, 35, 66, .08);
    transition: transform .2s ease, box-shadow .2s ease;
    cursor: pointer;

    &:hover {
      transform: scale(1.12);
      box-shadow: 0 6px 14px rgba(255, 49, 118, .18);
      z-index: 2;
      position: relative;
    }

    &__error {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #c0c4cc;
      font-size: 18px;
      background: #f7f8fa;
    }
  }

  .pi-empty-text {
    color: $pi-text-muted;
    font-size: 12px;
  }

  // 行内"查看"链接按钮
  .pi-link-btn {
    margin-left: 0;

    &.is-plain {
      color: $pi-primary;
      border-color: rgba(255, 49, 118, .5);
      background: #fff;

      &:hover {
        color: #fff;
        background: $pi-primary;
        border-color: $pi-primary;
      }
    }
  }

  // 操作按钮（修改/删除）
  .pi-op-btn {
    margin-left: 6px;
    border-radius: 8px;
    font-size: 12px;

    &.pi-op-btn--primary {
      color: $pi-primary;
      border-color: rgba(255, 49, 118, .4);
      background: #fff;

      &:hover {
        background: $pi-primary;
        border-color: $pi-primary;
        color: #fff;
      }
    }

    &.pi-op-btn--danger {
      color: #f56c6c;
      border-color: rgba(245, 108, 108, .4);
      background: #fff;

      &:hover {
        background: #f56c6c;
        border-color: #f56c6c;
        color: #fff;
      }
    }
  }
}

</style>

// ===== 页面布局高度链（按路由名命名的类，仅在当前页面存在，不属全局） =====
// 外层 el-main / inner / router-view 需有确定高度，表格卡片才能撑满视口
<style lang="scss">
.product_ingredients_main {
  height: calc(100vh - 84px);
  overflow: hidden;
}

.product_ingredients_main-inner {
  height: 100%;
}

.product_ingredients_main-inner__content {
  height: 100%;
}

// ===== 成分表弹窗（append-to-body，独立非 scoped 命名空间，不影响其他弹窗） =====
.pi-ingredient-dialog {
  border-radius: 14px;
  overflow: hidden;

  &.el-dialog {
    box-shadow: 0 12px 40px rgba(31, 35, 66, .16);
  }

  .el-dialog__header {
    background: linear-gradient(180deg, #fafbff, #f4f5fb);
    border-bottom: 1px solid #eef0f5;
    padding: 16px 20px;

    .el-dialog__title {
      font-weight: 600;
      color: #303133;
    }
  }

  .el-dialog__body {
    padding: 16px 20px 20px;
    background: #fff;
  }

  .pi-dialog-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 14px;
  }

  .pi-btn-primary {
    background: #ff3176;
    border-color: #ff3176;
    color: #fff;

    &:hover {
      background: #ff6b9a;
      border-color: #ff6b9a;
    }
  }

  .pi-btn-sync {
    border-radius: 8px;

    &:hover {
      opacity: .88;
    }
  }

  .pi-dialog-table {
    .el-table th.el-table__cell {
      background: #fafbff;
      color: #4a4e63;
      font-weight: 600;
    }

    .el-table .el-table__row:hover > td.el-table__cell {
      background: #fff0f5 !important;
    }
  }

  .pi-dialog-pager {
    margin-top: 14px;
    justify-content: flex-end;

    .el-pager li {
      border-radius: 6px;

      &.active {
        background: #ff3176;
        color: #fff;
      }
    }
  }
}
</style>
